import React from 'react'
import { connect } from 'react-redux'

import moment from 'moment'

import { DatePicker } from '@material-ui/pickers'

// import { fetchData } from '../../actions'
import dispatchPeriods from './actions'

// import { clearDataFromSession } from '../../utils'

import './index.scss'

class PeriodPicker extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedStartDate: null,
            selectedEndDate: null,
        }

        this.dateChangeHandler = this.dateChangeHandler.bind(this)
    }

    componentDidMount() {
        const selectedStartDate = moment().utc().subtract(1, 'days')

        const selectedEndDate = moment().utc()

        this.setState({ selectedStartDate, selectedEndDate }, () => {
            this.checkIfPeriodSelected()
        })
    }

    dateChangeHandler(type, value) {
        if (type === 'start') {
            this.setState(
                {
                    selectedStartDate: value,
                    selectedEndDate: null,
                },
                () => this.checkIfPeriodSelected()
            )
        } else if (type === 'end') {
            this.setState({ selectedEndDate: value }, () => this.checkIfPeriodSelected())
        }
    }

    checkIfPeriodSelected() {
        const { selectedStartDate, selectedEndDate } = this.state

        if (selectedStartDate && selectedEndDate) {
            const start = selectedStartDate
                .set('hours', 0)
                .set('minutes', 0)
                .set('seconds', 0)
                .valueOf()

            const end = selectedEndDate
                .set('hours', 23)
                .set('minutes', 59)
                .set('seconds', 59)
                .valueOf()

            this.props.dispatchPeriods({ start, end })

            // this.props.fetchData(selectedStartDate, selectedEndDate)
            // clearDataFromSession()
        }
    }

    render() {
        return (
            <div className='header-component periods'>
                <div className='period'>
                    <span>From</span>
                    <DatePicker
                        disableToolbar
                        autoOk={true}
                        variant='inline'
                        format='DD MMMM'
                        value={this.state.selectedStartDate}
                        onChange={e => this.dateChangeHandler('start', e)}
                    />
                </div>

                <div className='period'>
                    <span>To</span>
                    <DatePicker
                        disableToolbar
                        autoOk={true}
                        variant='inline'
                        format='DD MMMM'
                        value={this.state.selectedEndDate}
                        disabled={!this.state.selectedStartDate}
                        minDate={this.state.selectedStartDate}
                        onChange={value => this.dateChangeHandler('end', value)}
                    />
                </div>
            </div>
        )
    }
}

export default connect(null, {
    dispatchPeriods,
})(PeriodPicker)
